import React from 'react';
import { Route, Routes } from 'react-router-dom';
import Sidebar from '../Sidebar';
import ItemList from './ItemList';

function Dashboard() {
  return (
    <div style={{ display: 'flex' }}>
      <h1>Dashboard</h1>
    </div>
  );
}

export default Dashboard;
